import React from 'react';
import styled from '@emotion/styled';
import { useContent } from 'context/ContentContext';

const AboutSection = styled.section`
  padding: 4rem 2rem;
  text-align: center;
  background-color: #e8dcc8;
  background-image: url('https://storage.googleapis.com/birreria-el-semaforo/images/background/l.webp');
  background-repeat: repeat;
  background-size: 700px;
  background-blend-mode: multiply;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
`;

const SectionTitle = styled.h2`
  font-size: clamp(3.6rem, 3vw, 4.8rem);
  font-weight: 700;
  text-align: center;
  font-family: ${({ theme }) => theme.fonts.primary};
  color: ${({ theme }) => theme.colors.primary};
  line-height: 1.2;
`;

const ContentColumn = styled.div`
  max-width: 800px;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const Paragraph = styled.p`
  font-size: clamp(1.2rem, 2vw, 1.6rem);
  line-height: 1.5em;
  color: ${({ theme }) => theme.colors.text};
  font-family: ${({ theme }) => theme.fonts.secondary};
`;

const ImageGallery = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;

  ${({ theme }) => theme.mediaQueries.md} {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const Image = styled.img`
  width: 100%;
  aspect-ratio: 4/3;
  object-fit: cover;
  display: block;
  border-radius: 8px;
`;

const About = () => {
  const { about = {} } = useContent();
  const { title = '', info = '', galleryImages = [] } = about;

  return (
    <AboutSection id="about">
      <Container>
        <ContentColumn>
          <SectionTitle>{title}</SectionTitle>
          <Paragraph>{info}</Paragraph>
        </ContentColumn>
        <ImageGallery>
          {galleryImages.map((image, index) => (
            <Image key={index} src={image} alt="" loading="lazy" />
          ))}
        </ImageGallery>
      </Container>
    </AboutSection>
  );
};

export default About;
